import styled from "styled-components";

import { windowWidth } from "@styles/global";

const Container = styled.nav`
  background-color: ${(props) => props.theme.colors.background};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  height: 60px;
  flex-shrink: 0;
  box-shadow: 0 1px 0 rgba(0, 53, 99, 0.09);
  z-index: 20;
  width: 100%;
  color: ${(props) => props.theme.brand.navy};
  > :first-child {
    display: none;
    visibility: hidden;

    @media ( max-width: ${windowWidth.tablet} ) {
      display: block;
      visibility: visible;
      cursor: pointer;

      :not(:hover) {
        transition: all 0.2s;
      }

      :hover {
        transition: all 0.5s;
        transform: scale(1.2);
      }
    }
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { Container, LogoContainer };
